import { ParamIds, Places } from '../../../Constants'
import { MainKeys } from '../../../main/Main.keys'

export class BillingKeys extends MainKeys {
    get place() {
        return Places.billing
    }

    get startMonth() {
        return this._intent.getParameterAsString(ParamIds.billingStart)
    }

    set startMonth(value: string | undefined) {
        this._intent.setParameter(ParamIds.billingStart, value)
    }

    get endMonth() {
        return this._intent.getParameterAsString(ParamIds.billingEnd)
    }

    set endMonth(value: string | undefined) {
        this._intent.setParameter(ParamIds.billingEnd, value)
    }

    get month() {
        return this._intent.getParameterAsString(ParamIds.billingMonth)
    }

    set month(value: string | undefined) {
        this._intent.setParameter(ParamIds.billingMonth, value)
    }

    get onlyExceeded() {
        return this._intent.getParameterAsBoolean(ParamIds.billingOnlyExceeded)
    }

    set onlyExceeded(value: boolean | undefined) {
        this._intent.setParameter(ParamIds.billingOnlyExceeded, value)
    }

    get groupId() {
        return this._intent.getParameterAsNumber(ParamIds.billingGroup)
    }

    set groupId(value: number | undefined) {
        this._intent.setParameter(ParamIds.billingGroup, value)
    }
}

export default BillingKeys
